import { on } from '@ngrx/store';

import { emptyState, errorState, loadingState, resultState } from '../../@core/fetch-state.utils';
import { AppState } from '../app.state.interface';

import { ClientsApiActions } from './clients.actions';
import { ClientsState } from './clients.state.interface';

export const clientsStateFactory: ClientsState = {
  clients: emptyState(),
  clientsTotalCount: 0,
  addedClient: emptyState(),
  loadedClient: emptyState(),
  updatedClient: emptyState(),
  duplicatedClient: emptyState(),
  countries: emptyState(),
  statesForAddress1: emptyState(),
  statesForAddress2: emptyState(),
};

export const clientsStateReducers = [
  // Load clients actions
  on(ClientsApiActions.loadClients, (state: AppState) => ({
    ...state,
    clients: loadingState(),
    clientsTotalCount: 0,
  })),

  on(ClientsApiActions.loadClientsSuccess, (state: AppState, { clients, totalCount }) => ({
    ...state,
    clients: resultState(clients),
    clientsTotalCount: totalCount,
  })),

  on(ClientsApiActions.loadClientsError, (state: AppState, { error }) => ({
    ...state,
    clients: errorState([error]),
  })),

  // Add client actions
  on(ClientsApiActions.addClient, (state: AppState) => ({
    ...state,
    addedClient: loadingState(),
  })),

  on(ClientsApiActions.addClientSuccess, (state: AppState, { client }) => ({
    ...state,
    addedClient: resultState(client),
  })),

  on(ClientsApiActions.addClientError, (state: AppState, { error }) => ({
    ...state,
    addedClient: errorState([error]),
  })),

  // Load specific client actions
  on(ClientsApiActions.loadClient, (state: AppState) => ({
    ...state,
    loadedClient: loadingState(),
  })),

  on(ClientsApiActions.loadClientSuccess, (state: AppState, { client }) => ({
    ...state,
    loadedClient: resultState(client),
  })),

  on(ClientsApiActions.loadClientError, (state: AppState, { error }) => ({
    ...state,
    loadedClient: errorState([error]),
  })),

  // Update client actions
  on(ClientsApiActions.updateClient, (state: AppState) => ({
    ...state,
    updatedClient: loadingState(),
  })),

  on(ClientsApiActions.updateClientSuccess, (state: AppState, { client }) => ({
    ...state,
    updatedClient: resultState(client),
  })),

  on(ClientsApiActions.updateClientError, (state: AppState, { error }) => ({
    ...state,
    updatedClient: errorState([error]),
  })),

  // Duplicate client actions
  on(ClientsApiActions.duplicateClient, (state: AppState) => ({
    ...state,
    duplicatedClient: loadingState(),
  })),

  on(ClientsApiActions.duplicateClientSuccess, (state: AppState, { client }) => ({
    ...state,
    duplicatedClient: resultState(client),
  })),

  on(ClientsApiActions.duplicateClientError, (state: AppState, { error }) => ({
    ...state,
    duplicatedClient: errorState([error]),
  })),

  // Load countries actions
  on(ClientsApiActions.loadCountries, (state: AppState) => ({
    ...state,
    countries: loadingState(),
  })),

  on(ClientsApiActions.loadCountriesSuccess, (state: AppState, { countries }) => ({
    ...state,
    countries: resultState(countries),
  })),

  on(ClientsApiActions.loadCountriesError, (state: AppState, { error }) => ({
    ...state,
    countries: errorState([error]),
  })),

  // Load states actions
  on(ClientsApiActions.loadStatesForAddress1, (state: AppState) => ({
    ...state,
    statesForAddress1: loadingState(),
  })),

  on(ClientsApiActions.loadStatesForAddress1Success, (state: AppState, { states }) => ({
    ...state,
    statesForAddress1: resultState(states),
  })),

  on(ClientsApiActions.loadStatesForAddress1Error, (state: AppState, { error }) => ({
    ...state,
    statesForAddress1: errorState([error]),
  })),

  // Load states for address 2 actions
  on(ClientsApiActions.loadStatesForAddress2, (state: AppState) => ({
    ...state,
    statesForAddress2: loadingState(),
  })),

  on(ClientsApiActions.loadStatesForAddress2Success, (state: AppState, { states }) => ({
    ...state,
    statesForAddress2: resultState(states),
  })),

  on(ClientsApiActions.loadStatesForAddress2Error, (state: AppState, { error }) => ({
    ...state,
    statesForAddress2: errorState([error]),
  })),
];
